import { BaseMiddleware } from '@makemydeal/dr-activities-common';
import type { Store } from 'redux';
import type { Selectors } from './selectors';

export class MiddlewareManager extends BaseMiddleware {
    constructor(public selectors: Selectors, public analyticsAction?: (store: any, key: string, desc: string) => void) {
        super(selectors, analyticsAction);
    }

    protected middlewareFunction = (store: Store<any>, _next: any, action: any): void => {
        switch (action.type) {
            // Add credit app specific middleware logic here
            default: {
                break;
            }
        }
    };
}
